/* eslint-disable no-self-assign */
import OverLapMeetings from '../libs/overlapApi';

const loopingCondition = (hosts) =>
{
	const userIdsMatched = [];

	for (const emailObj of hosts)
	{
		if (emailObj.license === -1 && !(emailObj.limitLicense))
		{
			userIdsMatched.push(emailObj.userId);
		}
	}

	return userIdsMatched;
};

const getAvailableSeats = async (
	startTime,
	endTimeUTC,
	_license,
	userId,
	selectedLicense,
	availableLicense,
	userAuthPayload,
	mId
) =>
{
	let _usedLimit = 0;

	let availableSeats = 0;

	if (selectedLicense?.licenseObj?.hosts && selectedLicense?.licenseObj?.isConcurrent)
	{
		const loopReturnVar = loopingCondition(selectedLicense?.licenseObj?.hosts).concat(selectedLicense?.licenseObj?.licenseTo);

		if (userAuthPayload?.attributes && loopReturnVar.includes(userAuthPayload.attributes.sub))
		{
			const query = `?newUserId=${loopReturnVar.toString()}`;

			try
			{
				const overLapRes = await OverLapMeetings(startTime, endTimeUTC, _license, userId, query);

				overLapRes.forEach((item) =>
				{

					// _usedLimit += item.participantLimit;
					if (!mId)
					{
						_usedLimit += item?.participantLimit;
					}
					if (mId && item._id === mId)
					{
						_usedLimit = _usedLimit;
					}
					else if (mId && item._id !== mId)
					{
						_usedLimit += item?.participantLimit;
					}
				});

				availableSeats = availableLicense - _usedLimit;
			}
			catch (err)
			{
				console.log('errrr', err);
			}
		}
		else
		{
			try
			{
				const overLapRes = await OverLapMeetings(startTime, endTimeUTC, _license, userId);

				overLapRes?.forEach((item) =>
				{
					// _usedLimit += item.participantLimit;
					if (!mId)
					{
						_usedLimit += item?.participantLimit;
					}
					if (mId && item._id === mId)
					{
						_usedLimit = _usedLimit;
					}
					else if (mId && item._id !== mId)
					{
						_usedLimit += item?.participantLimit;
					}
				});

				availableSeats = availableLicense - _usedLimit;
			}
			catch (err)
			{
				console.log('errrr', err);
			}
		}
	}
	else
	{
		try
		{
			const overLapRes = await OverLapMeetings(startTime, endTimeUTC, _license, userId);

			overLapRes?.forEach((item) =>
			{
				// _usedLimit += item.participantLimit;
				if (!mId)
				{
					_usedLimit += item?.participantLimit;
				}
				if (mId && item._id === mId)
				{
					_usedLimit = _usedLimit;
				}
				else if (mId && item._id !== mId)
				{
					_usedLimit += item?.participantLimit;
				}
			});

			availableSeats = availableLicense - _usedLimit;

		}
		catch (err)
		{
			console.log('errrr', err);
		}
	}

	return availableSeats;
};

export default getAvailableSeats;